import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  TextField,
  Button,
  useMediaQuery,
} from "@mui/material";
import PlayerHistoryPopup from "./PlayerHistoryPopup";
import DragonTigerResultsPopup from "./DragonTigerResultsPopup";
import CasinoResultsPopup from "./CasinoResultsPopup";
import styles from "./Dragon_Tiger_used.module.css";
import BetScreen from "./BetScreen";
import casino_banner from "../../../images/casino_banner.png";
import FooterLinks from "../FooterLinks";
import { useLocation } from "react-router-dom";
import GameScreen from "./GameScreen";
import FlipClock from "../../FlipClock/FlipClock";
import useCasinoBetplace from "../../../api/useCasinoBetplace";
import useRoundLoader from "../../../api/useRoundLoader";

const bettingOptions = [
  { label: "Dragon", odds: 1.98, betType: "dragon" },
  { label: "Pair", odds: 12, betType: "pair" },
  { label: "Tiger", odds: 1.98, betType: "tiger" },
];

const redLabel = (
  <Box display="flex" justifyContent="center" gap={1}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M16 8L8 16L0 8L8 0L16 8Z" fill="url(#paint0_linear_both1)" />
      <defs>
        <linearGradient
          id="paint0_linear_both1"
          x1="3.336"
          y1="3.99543"
          x2="11.2419"
          y2="13.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE5B42" />
          <stop offset="1" stopColor="#BA0000" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.7305 1.44C13.0378 -0.48 10.3174 -0.48 8.62468 1.44L8 2.14857L7.37531 1.44C5.68262 -0.48 2.96222 -0.48 1.26952 1.44C-0.423174 3.36 -0.423174 6.44571 1.26952 8.36571L8 16L14.7305 8.36571C16.4232 6.44571 16.4232 3.33714 14.7305 1.44Z"
        fill="url(#paint0_linear_both2)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_both2"
          x1="3.10791"
          y1="-0.661257"
          x2="14.1232"
          y2="9.04996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE5B42" />
          <stop offset="1" stopColor="#BA0000" />
        </linearGradient>
      </defs>
    </svg>
  </Box>
);

const blackLabel = (
  <Box display="flex" justifyContent="center" gap={1}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.0167 5.77483C11.8053 5.77483 11.605 5.79603 11.4159 5.81722C11.7942 5.23444 12.0167 4.5457 12.0167 3.81457C12.0167 1.70596 10.2253 0 8.01113 0C5.79694 0 4.00556 1.70596 4.00556 3.81457C4.00556 4.55629 4.22809 5.23444 4.6064 5.81722C4.40612 5.78543 4.20584 5.77483 4.00556 5.77483C1.79138 5.77483 0 7.48079 0 9.5894C0 11.698 1.79138 13.404 4.00556 13.404C5.363 13.404 6.55355 12.7576 7.27677 11.7828C7.32128 13.5417 6.7427 14.9298 5.61892 16H10.3811C9.26843 14.9298 8.68985 13.5417 8.72323 11.7828C9.44645 12.7576 10.637 13.404 11.9944 13.404C14.2086 13.404 16 11.698 16 9.5894C16 7.48079 14.2198 5.77483 12.0167 5.77483Z"
        fill="url(#paint0_linear_6976_19405)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6976_19405"
          x1="2.66737"
          y1="3.51682"
          x2="12.8332"
          y2="14.1928"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454545" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.7396 6.4L8.0015 0L1.26339 6.4C-0.421131 8 -0.421131 10.6057 1.26339 12.2057C2.92385 13.7829 5.57097 13.8057 7.25549 12.2971C7.1833 13.8286 6.60575 15.04 5.59503 16H10.3839C9.37318 15.04 8.79563 13.8057 8.72343 12.2971C10.408 13.8057 13.0791 13.7829 14.7155 12.2057C16.4241 10.5829 16.4241 8 14.7396 6.4Z"
        fill="url(#paint0_linear_6976_19406)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6976_19406"
          x1="3.10819"
          y1="4.64503"
          x2="12.397"
          y2="14.4222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454545" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  </Box>
);

const dragonExtraBets = [
  { label: "Even", odds: 2.1, betType: "dragon_even" },
  { label: "Odd", odds: 1.79, betType: "dragon_odd" },
  { odds: 1.95, betType: "dragon_red", label: redLabel },
  { odds: 1.95, betType: "dragon_black", label: blackLabel },
];

const tigerExtraBets = [
  { label: "Even", odds: 2.1, betType: "tiger_even" },
  { label: "Odd", odds: 1.79, betType: "tiger_odd" },
  { odds: 1.95, betType: "tiger_red", label: redLabel },
  { odds: 1.95, betType: "tiger_black", label: blackLabel },
];

const LockIcon = () => (
  <Box className={styles.bettinglocked_icon_container}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
        fill="white"
      />
    </svg>
  </Box>
);

const cardValues = [
  { label: "A", value: "a" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "J", value: "j" },
  { label: "Q", value: "q" },
  { label: "K", value: "k" },
];

const CardIconsSVG = () => (
  <Box className={styles.Cards_icon}>
    <Box>
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="5"
          viewBox="0 0 6 5"
          fill="none"
        >
          <path
            d="M5.03191 2L2.92625 0L0.820592 2C0.294178 2.5 0.294178 3.31429 0.820592 3.81429C1.33949 4.30714 2.16671 4.31429 2.69312 3.84286C2.67056 4.32143 2.49008 4.7 2.17423 5H3.67075C3.3549 4.7 3.17442 4.31429 3.15185 3.84286C3.67827 4.31429 4.51301 4.30714 5.02439 3.81429C5.55832 3.30714 5.55832 2.5 5.03191 2Z"
            fill="url(#paint0_linear_7156_20672)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_7156_20672"
              x1="1.39709"
              y1="1.45157"
              x2="4.29985"
              y2="4.50693"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#454545" />
              <stop offset="1" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="5"
          viewBox="0 0 6 5"
          fill="none"
        >
          <path
            d="M5.34766 2.5L2.84766 5L0.347656 2.5L2.84766 0L5.34766 2.5Z"
            fill="url(#paint0_linear_7156_8036)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_7156_8036"
              x1="1.39016"
              y1="1.24857"
              x2="3.86074"
              y2="4.13092"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FE5B42" />
              <stop offset="1" stopColor="#BA0000" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Box>
    <Box>
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="5"
          viewBox="0 0 6 5"
          fill="none"
        >
          <path
            d="M4.181 1.80464C4.11493 1.80464 4.05235 1.81126 3.99324 1.81788C4.11146 1.63576 4.181 1.42053 4.181 1.19205C4.181 0.533113 3.62119 0 2.92926 0C2.23733 0 1.67752 0.533113 1.67752 1.19205C1.67752 1.42384 1.74706 1.63576 1.86528 1.81788C1.80269 1.80795 1.74011 1.80464 1.67752 1.80464C0.985587 1.80464 0.425781 2.33775 0.425781 2.99669C0.425781 3.65563 0.985587 4.18874 1.67752 4.18874C2.10172 4.18874 2.47376 3.98676 2.69977 3.68212C2.71368 4.23179 2.53287 4.66556 2.18169 5H3.66987C3.32217 4.66556 3.14136 4.23179 3.15179 3.68212C3.3778 3.98676 3.74984 4.18874 4.17404 4.18874C4.86598 4.18874 5.42578 3.65563 5.42578 2.99669C5.42578 2.33775 4.86945 1.80464 4.181 1.80464Z"
            fill="url(#paint0_linear_7156_20675)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_7156_20675"
              x1="1.25933"
              y1="1.09901"
              x2="4.43616"
              y2="4.43524"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#454545" />
              <stop offset="1" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="5"
          viewBox="0 0 6 5"
          fill="none"
        >
          <path
            d="M4.95093 0.45C4.42196 -0.15 3.57184 -0.15 3.04287 0.45L2.84766 0.671428L2.65244 0.45C2.12347 -0.15 1.27335 -0.15 0.744382 0.45C0.215414 1.05 0.215414 2.01429 0.744382 2.61429L2.84766 5L4.95093 2.61429C5.4799 2.01429 5.4799 1.04286 4.95093 0.45Z"
            fill="url(#paint0_linear_7156_8039)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_7156_8039"
              x1="1.31888"
              y1="-0.206643"
              x2="4.76116"
              y2="2.82811"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FE5B42" />
              <stop offset="1" stopColor="#BA0000" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    </Box>
  </Box>
);

const LockSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
      fill="white"
    />
  </svg>
);

const Dragon_Tiger = ({
  onBetSelect,
  locked,
  settledData,
  socketData,
  gameId = 6,
  casinoBets = [],
  hookExposureData
}) => {
  const [timer, setTimer] = useState(30);
  const isLargeScreen = useMediaQuery("(min-width:1024px)");
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
  const [gameActive, setGameActive] = useState(true);
  const roundId = socketData?.roundId;
 
  const [exposureData, setExposureData] = useState(null);
  useEffect(() => {
  console.log("🟣 LOCAL exposureData is now:", exposureData);
}, [exposureData]);
  const showLoader = useRoundLoader(roundId);
  const [animTimer, setAnimTimer] = useState(null);
   const prevRoundIdRef = useRef(null);
   
 
  const getExposureValue = (key) => {
    if (!exposureData) return null;

    const keyMap = {
      dragon: "ifDragonWins",
      tiger: "ifTigerWins",
      pair: "ifPair",

      dragon_even: "ifDragonEven",
      dragon_odd: "ifDragonOdd",
      dragon_red: "ifDragonRed",
      dragon_black: "ifDragonBlack",

      tiger_even: "ifTigerEven",
      tiger_odd: "ifTigerOdd",
      tiger_red: "ifTigerRed",
      tiger_black: "ifTigerBlack",

      dragon_a: "ifDragonA",
      dragon_2: "ifDragon2",
      dragon_3: "ifDragon3",
      dragon_4: "ifDragon4",
      dragon_5: "ifDragon5",
      dragon_6: "ifDragon6",
      dragon_7: "ifDragon7",
      dragon_8: "ifDragon8",
      dragon_9: "ifDragon9",
      dragon_10: "ifDragon10",
      dragon_j: "ifDragonJ",
      dragon_q: "ifDragonQ",
      dragon_k: "ifDragonK",

      tiger_a: "ifTigerA",
      tiger_2: "ifTiger2",
      tiger_3: "ifTiger3",
      tiger_4: "ifTiger4",
      tiger_5: "ifTiger5",
      tiger_6: "ifTiger6",
      tiger_7: "ifTiger7",
      tiger_8: "ifTiger8",
      tiger_9: "ifTiger9",
      tiger_10: "ifTiger10",
      tiger_j: "ifTigerJ",
      tiger_q: "ifTigerQ",
      tiger_k: "ifTigerK",
    };

    const val = exposureData[keyMap[key] ?? key];
    if (val === undefined || val === null) return null;
    return val;
  };

  const ExposureLabel = ({ value }) => {
    if (value === null || value === undefined || value === 0) return null;

    return (
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 600,
          color: value < 0 ? "#ff4444" : "#00c853",
          textAlign: "center",
          lineHeight: 1,
          mt: "4px",
          mb: "2px",
          width: "100%",
          display: "block",
        }}
      >
        {value}
      </Typography>
    );
  };
  // ===== End exposure helper =====

  const handleBetSubmit = () => {
    setBetDialogOpen(false);
  };

  const dummyBets = [
    { betType: "dragon", selection: "DRAGON", amount: 100, rate: 2 },
    { betType: "dragon_even", selection: "DRAGON_EVEN", amount: 50, rate: 2.1 },
    { betType: "tiger", selection: "TIGER", amount: 200, rate: 2 },
  ];

  const activeBets = casinoBets.length > 0 ? casinoBets : casinoBets;

useEffect(() => {
  if (hookExposureData === null) {
    setExposureData(null);
    return;
  }

  if (hookExposureData.roundId && hookExposureData.roundId !== roundId) {
    return; 
  }
  setExposureData(hookExposureData);
}, [hookExposureData, roundId]);



useEffect(() => {
 
  if (roundId && prevRoundIdRef.current != null && prevRoundIdRef.current !== roundId) {
   
    setExposureData(null);
  }
  prevRoundIdRef.current = roundId;
}, [roundId]);


  const getExposure = (betType) => {
    const matched = activeBets.filter((b) => {
      const sel = (b.selection || "").toLowerCase();
      const bt = betType.toLowerCase();

      return sel === bt;
    });
    if (matched.length === 0) return null;
    const bet = matched[matched.length - 1];
    return {
      amount: parseFloat(bet.stake),
      rate: parseFloat(bet.rate),
      exposure: parseFloat(bet.exposure),
    };
  };
  const handleNewRound = useCallback(() => {
    setTimer(10);
    setGameActive(true);
  }, []);

  const [isAnimationStarted, setIsAnimationStarted] = useState(false);

  useEffect(() => {
    if (isAnimationStarted) return;
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setIsAnimationStarted(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdown);
  }, [isAnimationStarted]);

  const handleStageComplete = () => {
    setIsAnimationStarted(false);
    setTimer(30);
  };

  const isBettingLocked =
    locked || socketData?.bettingClosed || !socketData?.remainingTime;

  const handleBetClick = (bet) => {
    if (!locked) {
      const mainBetTypes = ["dragon", "tiger", "pair"];
      const marketName = mainBetTypes.includes(bet.betType) ? "MAIN" : "SIDE";
      onBetSelect({
        ...bet,
        marketName,
        selection: bet.betType.toUpperCase(),
      });
    }
  };

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
  
      <Box className={styles.MatchScreen_container}>
        <Box sx={{ position: "relative", width: "100%" }}>
          <GameScreen
            socketData={socketData}
            onAnimStart={() => setAnimTimer(0)}
            onAnimEnd={() => setAnimTimer(null)}
          />

          <Box
            sx={{
              position: "absolute",
              bottom: "8px",
              right: "8px",
              zIndex: 10,
              pointerEvents: "none",
            }}
          >
            <FlipClock
              time={
                animTimer !== null ? animTimer : socketData?.remainingTime
              }
            />
          </Box>
        </Box>

        <>
          <Box className={styles.CasinoGames_container}>
            <Box className={styles.bettingOptions_container}>
              {bettingOptions.map((option) => {
                const exp = getExposure(option.betType);
                return (
                  <Box
                    key={option.label}
                    sx={{
                      minWidth: "32%",
                      alignSelf: "stretch",
                      position: "relative",
                      "&:hover": { cursor: locked ? "not-allowed" : "pointer" },
                    }}
                  >
                    <Typography className={styles.bettingOptions_txt}>
                      {locked ? "" : option.odds}
                    </Typography>
                    <Box
                      className={styles.bettingOptions_btn}
                      onClick={() => handleBetClick(option)}
                      sx={{ position: "relative" }}
                    >
                      <Typography className={styles.bettingOptions_btn_txt}>
                        {option.label}
                      </Typography>
                      {locked && (
                        <Box className={styles.bettinglocked_icon_container}>
                          <LockSVG />
                        </Box>
                      )}
                    </Box>
                    <ExposureLabel value={getExposureValue(option.betType)} />
                  </Box>
                );
              })}
            </Box>

            <Box className={styles.dRAGON_TIGER}>
              {/* Dragon Section */}
              <Box
                sx={{
                  width: "100% !important",
                  alignSelf: "stretch",
                  marginBottom: "16px",
                }}
              >
                <Typography className={styles.subtitle_txt}>DRAGON</Typography>
                <Box className={styles.extraBets_container}>
                  {dragonExtraBets.map((opt, index) => {
                    const exp = getExposure(opt.betType);
                    return (
                      <Box
                        key={`dragon-${index}`}
                        sx={{
                          minWidth: "48%",
                          alignSelf: "stretch",
                          position: "relative",
                          "&:hover": {
                            cursor: locked ? "not-allowed" : "pointer",
                          },
                        }}
                      >
                        <Typography className={styles.bettingOptions_txt}>
                          {locked ? 0 : opt.odds}
                        </Typography>
                        <Box
                          className={styles.bettingOptions_btn}
                          onClick={() => handleBetClick(opt)}
                          sx={{ position: "relative" }}
                        >
                          <Typography className={styles.bettingOptions_btn_txt}>
                            {opt.label}
                          </Typography>
                          {locked && (
                            <Box
                              className={styles.bettinglocked_icon_container}
                            >
                              <LockSVG />
                            </Box>
                          )}
                        </Box>
                        <ExposureLabel value={getExposureValue(opt.betType)} />
                      </Box>
                    );
                  })}
                </Box>
              </Box>

              {/* Tiger Section */}
              <Box
                sx={{
                  width: "100% !important",
                  alignSelf: "stretch",
                  marginBottom: "16px",
                }}
              >
                <Typography className={styles.subtitle_txt}>TIGER</Typography>
                <Box className={styles.extraBets_container}>
                  {tigerExtraBets.map((opt, index) => {
                    const exp = getExposure(opt.betType);
                    return (
                      <Box
                        key={`tiger-${index}`}
                        sx={{
                          minWidth: "48%",
                          alignSelf: "stretch",
                          position: "relative",
                          "&:hover": {
                            cursor: locked ? "not-allowed" : "pointer",
                          },
                        }}
                      >
                        <Typography className={styles.bettingOptions_txt}>
                          {locked ? 0 : opt.odds}
                        </Typography>
                        <Box
                          className={styles.bettingOptions_btn}
                          onClick={() => handleBetClick(opt)}
                          sx={{ position: "relative" }}
                        >
                          <Typography className={styles.bettingOptions_btn_txt}>
                            {opt.label}
                          </Typography>
                          {locked && (
                            <Box
                              className={styles.bettinglocked_icon_container}
                            >
                              <LockSVG />
                            </Box>
                          )}
                        </Box>
                        <ExposureLabel value={getExposureValue(opt.betType)} />
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>

            <Box className={styles.dRAGON_TIGER}>
              {/* Cards Section - DRAGON 12 */}
              <Box
                sx={{
                  width: "100% !important",
                  alignSelf: "stretch",
                  marginBottom: "16px",
                }}
              >
                <Typography className={styles.subtitle_txt}>
                  DRAGON 12
                </Typography>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  className={styles.Cards_Section_container}
                >
                  {cardValues.map((card, i) => {
                    const exposureKey = `dragon_${card.value}`;
                    return (
                      <Box
                        key={`d-${i}`}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: locked ? "not-allowed" : "pointer",
                        }}
                        onClick={() =>
                          !locked &&
                          onBetSelect({
                            label: `Dragon ${card.label}`,
                            odds: 12,
                            betType: `dragon_${card.value}`,
                            marketName: "SIDE",
                            selection: `DRAGON_${card.value.toUpperCase()}`,
                          })
                        }
                      >
                        {/* Sirf card box pe Cards_container class lagao */}
                        <Box
                          className={styles.Cards_container}
                          sx={{ position: "relative" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                          >
                            <Typography className={styles.Cards_number}>
                              {card.label}
                            </Typography>
                          </Box>
                          <CardIconsSVG />
                          {locked && (
                            <Box className={styles.locked_icon_container}>
                              <LockSVG />
                            </Box>
                          )}
                        </Box>

                      
                        <ExposureLabel value={getExposureValue(exposureKey)} />
                      </Box>
                    );
                  })}
                </Box>
              </Box>

              {/* Cards Section - TIGER 12 */}
              <Box
                sx={{
                  width: "100% !important",
                  alignSelf: "stretch",
                  marginBottom: "16px",
                }}
              >
                <Typography className={styles.subtitle_txt}>
                  TIGER 12
                </Typography>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  className={styles.Cards_Section_container}
                >
                  {cardValues.map((card, i) => {
                    const exposureKey = `tiger_${card.value}`;
                    return (
                      <Box
                        key={`t-${i}`}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: locked ? "not-allowed" : "pointer",
                        }}
                        onClick={() =>
                          !locked &&
                          onBetSelect({
                            label: `Tiger ${card.label}`,
                            odds: 12,
                            betType: `tiger_${card.value}`,
                            marketName: "SIDE",
                            selection: `TIGER_${card.value.toUpperCase()}`,
                          })
                        }
                      >
                        {/* Card box - fixed size */}
                        <Box
                          className={styles.Cards_container}
                          sx={{ position: "relative" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                          >
                            <Typography className={styles.Cards_number}>
                              {card.label}
                            </Typography>
                          </Box>
                          <CardIconsSVG />
                          {locked && (
                            <Box className={styles.locked_icon_container}>
                              <LockSVG />
                            </Box>
                          )}
                        </Box>

                        {/* Exposure - card ke bilkul bahar niche */}
                        <ExposureLabel value={getExposureValue(exposureKey)} />
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>

            <FooterLinks
              socketData={socketData}
              settledData={settledData}
              gameType="Dragon_Tiger"
            />
          </Box>
        </>
      </Box>
  
  );
};

export default Dragon_Tiger;